import Images3d from '../../assets/images/3d_images.webp'
import BookOpen from '../../assets/images/book_open.webp'
import PexesoButtonHintDisabled from '../../assets/images/button_hint_disabled.webp'
import PexesoButtonHintEnabled from '../../assets/images/button_hint_enabled.webp'
import FirstPlace from '../../assets/images/classrooms/activities/1st_place.webp'
import SecondPlace from '../../assets/images/classrooms/activities/2nd_place.webp'
import ThirdPlace from '../../assets/images/classrooms/activities/3rd_place.webp'
import AnagramPreview from '../../assets/images/classrooms/activities/anagram_preview.webp'
import FlipcardsPreview from '../../assets/images/classrooms/activities/flipcards_preview.webp'
import HomeworkPreview from '../../assets/images/classrooms/activities/homework_preview_image.webp'
import HuntwordsPreview from '../../assets/images/classrooms/activities/huntwords_preview_image.webp'
import LinkmaniaPreview from '../../assets/images/classrooms/activities/linkmania_preview.webp'
import MillionairePreview from '../../assets/images/classrooms/activities/millionaire_preview.webp'
import PexesoGameCard from '../../assets/images/classrooms/activities/pexeso_card.webp'
import PexesoPreview from '../../assets/images/classrooms/activities/pexeso_preview_image.webp'
import PicsMatchPreview from '../../assets/images/classrooms/activities/picsmatch_preview.webp'
import QuizPreview from '../../assets/images/classrooms/activities/quiz_preview_image.webp'
import SelfStudyPreview from '../../assets/images/classrooms/activities/self_learning_preview_image.webp'
import SpellWizardsPreview from '../../assets/images/classrooms/activities/spell_wizard_preview.webp'
import Star from '../../assets/images/classrooms/activities/stars.webp'
import TeamLeaderboardBg from '../../assets/images/classrooms/activities/team_leaderboard_bg.webp'
import TestPreview from '../../assets/images/classrooms/activities/test_preview_image.webp'
import WheelPreview from '../../assets/images/classrooms/activities/wheel_preview_image.webp'
import WildWestPreview from '../../assets/images/classrooms/activities/wild_west_preview.webp'
import WordAhoyPreview from '../../assets/images/classrooms/activities/word_ahoy_preview.webp'
import WordLaddersPreview from '../../assets/images/classrooms/activities/word_ladders_preview.webp'
import WorksheetsFindWordsPreview from '../../assets/images/classrooms/activities/worksheets_find_words_preview.webp'
import WorksheetsMatchingElementsPreview from '../../assets/images/classrooms/activities/worksheets_matching_elements_preview.webp'
import WorksheetsOneToManyPreview from '../../assets/images/classrooms/activities/worksheets_one_to_many_preview.webp'
import CorrectTick from '../../assets/images/classrooms/correct_tick.svg'
import FoxinoMigrate from '../../assets/images/classrooms/foxino_migrate.webp'
import LockedLock from '../../assets/images/classrooms/locked_lock.webp'
import NoTextBook from '../../assets/images/classrooms/no_textbook.webp'
import NoStudentsAtRisk from '../../assets/images/classrooms/performance/no_students_at_risk.webp'
import NotableAchievers from '../../assets/images/classrooms/performance/notable_achievers_empty.webp'
import ListeningIcon from '../../assets/images/classrooms/progress/listening.webp'
import ReadingIcon from '../../assets/images/classrooms/progress/reading.webp'
import SpeakerIcon from '../../assets/images/classrooms/progress/speaker.webp'
import SpeakingIcon from '../../assets/images/classrooms/progress/speaking.webp'
import WritingIcon from '../../assets/images/classrooms/progress/writing.webp'
import TextBook from '../../assets/images/classrooms/textbook.webp'
import UnlockedLock from '../../assets/images/classrooms/unlocked_lock.webp'
import NoResultDictionary from '../../assets/images/dictionary/search_not_found.webp'
import FirstQrLogin from '../../assets/images/first_qr_login.webp'
import Logo from '../../assets/images/foxino_beta.svg'
import FirstTeacher from '../../assets/images/foxino_teacher.webp'
import WrongRights from '../../assets/images/insufficient_roles.webp'
import LearningPlanAnagramIcon from '../../assets/images/learning_plan_new/anagram_icon.webp'
import LearningPlanClassGameAssignment from '../../assets/images/learning_plan_new/class_games_assignment.webp'
import LearningPlanConnectIcon from '../../assets/images/learning_plan_new/connect_icon.webp'
import LearningPlanNewEditorBackground from '../../assets/images/learning_plan_new/editor_background.webp'
import LearningPlanFlashcardsIcon from '../../assets/images/learning_plan_new/flashcards_icon.webp'
import LearningPlanFlipcardsIcon from '../../assets/images/learning_plan_new/flipcards_icon.webp'
import LearningPlanFoxhootIcon from '../../assets/images/learning_plan_new/foxhoot_icon.webp'
import LearningPlanHomeworkAssignment from '../../assets/images/learning_plan_new/homework_assignment.webp'
import LearningPlanHuntwordsIcon from '../../assets/images/learning_plan_new/huntwords_icon.webp'
import LearningPlanLinkmaniaIcon from '../../assets/images/learning_plan_new/linkmania_icon.webp'
import LearningPlanMillionaireIcon from '../../assets/images/learning_plan_new/millionaire_icon.webp'
import LearningPlanNewPageNoContent from '../../assets/images/learning_plan_new/page_no_content.webp'
import LearningPlanPexesoIcon from '../../assets/images/learning_plan_new/pexeso_icon.webp'
import LearningPlanPrepositionsIcon from '../../assets/images/learning_plan_new/prepositions_icon.webp'
import LearningPlanSelfStudyAssignment from '../../assets/images/learning_plan_new/self_study_assignment.webp'
import LearningPlanSpellAhoyIcon from '../../assets/images/learning_plan_new/spell_ahoy_icon.webp'
import LearningPlaSpellWizardIcon from '../../assets/images/learning_plan_new/spell_wizard_icon.webp'
import LearningPlanTestAssignment from '../../assets/images/learning_plan_new/test_assignment.webp'
import LearningPlanWheelIcon from '../../assets/images/learning_plan_new/wheel_icon.webp'
import LearningPlanWildWestIcon from '../../assets/images/learning_plan_new/wild_west_icon.webp'
import LearningPlanWordLaddersIcon from '../../assets/images/learning_plan_new/word_ladders_icon.webp'
import LearningPlanWorksheetsAssignment from '../../assets/images/learning_plan_new/worksheets_assignment.webp'
import CollectionEmptyState from '../../assets/images/library/collection_empty_content.webp'
import FoxinoLibrary from '../../assets/images/library/foxino_library.webp'
import MaintenanceFoxino640w from '../../assets/images/maintenance/foxino_640w.webp'
import MaintenanceFoxino768w from '../../assets/images/maintenance/foxino_768w.webp'
import MaintenanceFoxino1024w from '../../assets/images/maintenance/foxino_1024w.webp'
import MaintenanceLogo from '../../assets/images/maintenance/logo.webp'
import MillionaireEditorCheckImg from '../../assets/images/millionaire/check_img.webp'
import MillionaireEditorInstructionArrow from '../../assets/images/millionaire/instruction_arrow.webp'
import MillionaireEditor from '../../assets/images/millionaire/millionaire_editor.webp'
import FoxinoClosedEye from '../../assets/images/purple_foxino_closed_eyes.webp'
import ArrowDown from '../../assets/images/quiz/arrow_drop_down_red.png'
import ArrowUp from '../../assets/images/quiz/arrow_drop_up_green.png'
import BadgeIcon from '../../assets/images/quiz/badge.webp'
import QuizCheckmark from '../../assets/images/quiz/checkmark.webp'
import QuizCheckmarkLines from '../../assets/images/quiz/checkmark_lines.webp'
import QuizConfetti from '../../assets/images/quiz/confetti.webp'
import FirstWinner from '../../assets/images/quiz/first_winner.webp'
import OkFoxino from '../../assets/images/quiz/ok_foxino_trimmed.webp'
import PersonIcon from '../../assets/images/quiz/person.webp'
import QuestionFrameBg from '../../assets/images/quiz/question_frame_bg.webp'
import QuizRedCross from '../../assets/images/quiz/red_cross.webp'
import SamePlace from '../../assets/images/quiz/same_place.png'
import SandClock from '../../assets/images/quiz/sand_clock.webp'
import SecondWinner from '../../assets/images/quiz/second_winner.webp'
import QuizCircleSymbol from '../../assets/images/quiz/svg/circle_symbol.svg'
import QuizCircleSymbolColor from '../../assets/images/quiz/svg/circle_symbol_color.svg'
import FoxinoQuizGameTitle from '../../assets/images/quiz/svg/foxino_quiz_game_title.svg'
import QrCodeBg from '../../assets/images/quiz/svg/qr_code_bg.svg'
import QrInputBg from '../../assets/images/quiz/svg/qr_input_bg.svg'
import QuizSquareSymbol from '../../assets/images/quiz/svg/square_symbol.svg'
import QuizSquareSymbolColor from '../../assets/images/quiz/svg/square_symbol_color.svg'
import QuizStarSymbol from '../../assets/images/quiz/svg/star_symbol.svg'
import QuizStarSymbolColor from '../../assets/images/quiz/svg/star_symbol_color.svg'
import QuizTriangleSymbol from '../../assets/images/quiz/svg/triangle_symbol.svg'
import QuizTriangleSymbolColor from '../../assets/images/quiz/svg/triangle_symbol_color.svg'
import ThirdWinner from '../../assets/images/quiz/third_winner.webp'
import Trophy from '../../assets/images/quiz/trophy.webp'
import TestWorksheet from '../../assets/images/test_worksheet.webp'

export const ImageContent = {
  logo: Logo,
  wrongRights: WrongRights,
  buttonHintDisabled: PexesoButtonHintDisabled,
  buttonHintEnabled: PexesoButtonHintEnabled,
  foxinoClosedEye: FoxinoClosedEye,
  firstQrLogin: FirstQrLogin,
  foxinoTeacher: FirstTeacher,
  bookOpen: BookOpen,

  test: {
    worksheet: TestWorksheet
  },
  learningPlan: {
    noContent: LearningPlanNewPageNoContent,
    editorBackground: LearningPlanNewEditorBackground,
    logos: {
      selfStudy: LearningPlanHomeworkAssignment,
      test: LearningPlanTestAssignment,
      homework: LearningPlanSelfStudyAssignment,
      game: LearningPlanClassGameAssignment,
      worksheet: LearningPlanWorksheetsAssignment
    },
    icon: {
      anagram: LearningPlanAnagramIcon,
      linkmania: LearningPlanLinkmaniaIcon,
      connect: LearningPlanConnectIcon,
      flashcards: LearningPlanFlashcardsIcon,
      flipcards: LearningPlanFlipcardsIcon,
      foxhoot: LearningPlanFoxhootIcon,
      millionaire: LearningPlanMillionaireIcon,
      huntwords: LearningPlanHuntwordsIcon,
      wheel: LearningPlanWheelIcon,
      spellAhoy: LearningPlanSpellAhoyIcon,
      pexeso: LearningPlanPexesoIcon,
      wildWest: LearningPlanWildWestIcon,
      wordLadder: LearningPlanWordLaddersIcon,
      spellWizard: LearningPlaSpellWizardIcon,
      prepositions: LearningPlanPrepositionsIcon
    }
  },

  quiz: {
    svg: {
      qrCodeBg: QrCodeBg,
      qrInputBg: QrInputBg,
      quizGameTitle: FoxinoQuizGameTitle,
      sandClock: SandClock,
      square: QuizSquareSymbol,
      squareColor: QuizSquareSymbolColor,
      circle: QuizCircleSymbol,
      circleColor: QuizCircleSymbolColor,
      star: QuizStarSymbol,
      starColor: QuizStarSymbolColor,
      triangle: QuizTriangleSymbol,
      triangleColor: QuizTriangleSymbolColor
    },
    arrowUp: ArrowUp,
    arrowDown: ArrowDown,
    samePlace: SamePlace,
    questionFrameBg: QuestionFrameBg,
    lobby: PersonIcon,
    badge: BadgeIcon,
    okFoxino: OkFoxino,
    sound: SpeakerIcon,
    trophy: Trophy,
    firstWinner: FirstWinner,
    secondWinner: SecondWinner,
    thirdWinner: ThirdWinner,
    confetti: QuizConfetti,
    checkmark: QuizCheckmark,
    checkmarkLine: QuizCheckmarkLines,
    redCross: QuizRedCross
  },

  millionaire: {
    editor: MillionaireEditor,
    instructionArrow: MillionaireEditorInstructionArrow,
    checkImg: MillionaireEditorCheckImg
  },

  classrooms: {
    foxinoMigrate: FoxinoMigrate,
    textbook: TextBook,
    noTextbook: NoTextBook,
    correctTick: CorrectTick,
    lockedLock: LockedLock,
    unlockedLock: UnlockedLock,
    cards: {
      pexesoCard: PexesoGameCard
    },
    activities: {
      anagramPreview: AnagramPreview,
      linkmaniaPreview: LinkmaniaPreview,
      selfStudyPreview: SelfStudyPreview,
      worksheetsFindWordsPreview: WorksheetsFindWordsPreview,
      worksheetsMatchingElementsPreview: WorksheetsMatchingElementsPreview,
      worksheetsOneToManyPreview: WorksheetsOneToManyPreview,
      quizPreview: QuizPreview,
      testPreview: TestPreview,
      pexesoPreview: PexesoPreview,
      homeworkPreview: HomeworkPreview,
      wheelPreview: WheelPreview,
      huntwordsPreview: HuntwordsPreview,
      flipcardsPreview: FlipcardsPreview,
      picsMatchPreview: PicsMatchPreview,
      millionairePreview: MillionairePreview,
      wordAhoyPreview: WordAhoyPreview,
      wordLaddersPreview: WordLaddersPreview,
      wildWestPreview: WildWestPreview,
      spellWizardsPreview: SpellWizardsPreview,
      teamLeaderboardBg: TeamLeaderboardBg,
      firstPlace: FirstPlace,
      secondPlace: SecondPlace,
      thirdPlace: ThirdPlace,
      star: Star
    },
    progress: {
      writing: WritingIcon,
      reading: ReadingIcon,
      listening: ListeningIcon,
      speaking: SpeakingIcon
    },
    performance: {
      noStudentsAtRisk: NoStudentsAtRisk,
      notableAchievers: NotableAchievers,
      achievements: {
        // TODO: replace with real images
        avidGamers: LearningPlanClassGameAssignment,
        bounceBacks: LearningPlanClassGameAssignment,
        cleverFoxes: LearningPlanClassGameAssignment,
        collectors: LearningPlanClassGameAssignment,
        explorers: LearningPlanClassGameAssignment,
        leaderboardFrogs: LearningPlanClassGameAssignment,
        notGivingUp: LearningPlanClassGameAssignment,
        powerLearners: LearningPlanClassGameAssignment,
        weekendWarriors: LearningPlanClassGameAssignment
      }
    }
  },

  dictionary: {
    noResult: NoResultDictionary,
    images3d: Images3d
  },

  library: {
    collectionEmptyState: CollectionEmptyState,
    foxinoLibrary: FoxinoLibrary
  },

  maintenance: {
    logo: MaintenanceLogo,
    foxino_640w: MaintenanceFoxino640w,
    foxino_768w: MaintenanceFoxino768w,
    foxino_1024w: MaintenanceFoxino1024w
  }
}
